import { getUsersData } from "Areas/Settings/users/redux/selectors";
import { security } from "Common/permissions";
import filter from "lodash/filter";
import map from "lodash/map";
import { connect } from "react-redux";
import parentActionCreators from "../../accessLevels/redux/actionCreators";
import actionCreators from "../redux/actionCreators";
import { getAccessLevelsKey } from "../redux/selectors";
import AccessLevelsEditor from "./accessLevelsEditor";
const mapStateToProps = (state) => ({
    selfUserId: security.getCurrentUserId(),
    users: getUsersData(state),
    accessLevelsKey: getAccessLevelsKey(state)
});
const mapDispatchToProps = (dispatch, ownProps) => ({
    onSave: (draft) => {
        Promise.all(map(filter(draft, "Changed"), accessLevel => !accessLevel.Deleted
            ? dispatch(actionCreators.saveAccessLevel(accessLevel))
            : dispatch(actionCreators.deleteAccessLevel(accessLevel)))).then(() => {
            dispatch(actionCreators.setAccessLevelsKey(undefined));
            dispatch(parentActionCreators.getPermissions(ownProps.entityId, ownProps.entityType));
        });
    }
});
export default connect(mapStateToProps, mapDispatchToProps)(AccessLevelsEditor);
